import React from 'react';
import { Routes, Route } from 'react-router-dom';
import SalesRepList from '../components/SalesRepList';  // Componente para listar los representantes de ventas
import SalesRepForm from '../components/SalesRepForm';  // Componente para el formulario de los representantes de ventas

const SalesRepsPage = () => {
    return (
        <div>
            <Routes>
                {/* Ruta para listar los representantes de ventas */}
                <Route path="/" element={<SalesRepList />} />

                {/* Ruta para crear un nuevo representante de ventas */}
                <Route path="/new" element={<SalesRepForm />} />

                {/* Ruta para editar un representante de ventas */}
                <Route path="/edit/:id" element={<SalesRepForm />} />
            </Routes>
        </div>
    );
};

export default SalesRepsPage;
